import camelCase from 'lodash.camelcase'

// Типы для модулей
interface VueComponent {
  name?: string
  data?: () => any
  props?: Record<string, any>
  methods?: Record<string, any>
  components?: Record<string, any>
  [key: string]: any
}

interface ModulesCollection {
  modules: Record<string, VueComponent>
  names: string[]
}

// Типизация для require.context (Webpack)
interface RequireContext {
  keys(): string[]
  <T = { default: VueComponent }>(id: string): T
  resolve(id: string): string
  id: number
}

// Функция для валидации имени модуля
const isValidModuleName = (fileName: string): boolean => {
  return !fileName.includes('index.js') && !fileName.includes('index.ts')
}

// Функция для извлечения имени файла
const getModuleName = (fileName: string): string => {
  return fileName.replace(/(\.\/|\.vue|\.ts)/g, '')
}

const requireModule: RequireContext = require.context(
  '@/nms/components/modal/components',
  false,
  /\.(vue|ts)$/
)

const modules: ModulesCollection = {
  modules: {},
  names: []
}

requireModule.keys().forEach((fileName: string) => {
  // Пропускаем index файлы
  if (!isValidModuleName(fileName)) return
  
  const name = getModuleName(fileName)
  const moduleName = camelCase(name)
  const moduleExport = requireModule<{ default: VueComponent }>(fileName)
  
  modules.names.push(name)
  modules.modules[moduleName] = moduleExport.default
})

export default modules